import { GET_PRODUCTS_AT_WAREHOUSE } from '../actions/types';

const initialState = {
  list: []
};

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case GET_PRODUCTS_AT_WAREHOUSE: {
      return { ...state, ...{ list: action.productsData } };
    }
    default:
      return state;
  }
}
